module.exports = __webpack_public_path__ + "static/media/icon-phone-blue.4025ba6d.svg";